import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    Box,
    Button,
    Paper,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import {
    Select as CALLREQUEST_SELECT,
    selectCategory as CATRGORY_SELECT_ALL,
    Insert as CALLREQUEST_INSERT
} from 'Components/Api/CallMeRequestAPI';
import { SelectParentWithAdminForCallMeRequest as SELECT_PARENT_WITH_ADMIN } from 'Components/Api/UsersApi';

import ReactTable from 'Components/ReactTable/ReactTable';
import {
    MESSAGE_CLOSE_AFTER,
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const CallMeRequest = () => {
    const classes = commonStyle();
    const [itemList, setItemList] = useState([]);
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [mainColumns, setMainColumns] = useState([]);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [requestToList, setRequestToList] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [Subject, setSubject] = useState([]);

    const selectCategory = async () => {
        const { isAuthorized, status, data } = await CATRGORY_SELECT_ALL();
        if (!isAuthorized) LOGOUT();
        if (!status) return;
        var d = JSON.parse(data);
        setSubject(d);
    };

    const selectParent = async () => {
        const { isAuthorized, status, data } = await SELECT_PARENT_WITH_ADMIN();

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setResponseMessage(data);
            setIsError(true);
            return;
        }

        var d = JSON.parse(data);
        setRequestToList(d);
    };

    const selectData = async () => {
        const { isAuthorized, status, data } = await CALLREQUEST_SELECT();
        setLoadingOpen(false);

        if (!isAuthorized) LOGOUT();

        if (!status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(data);

            return;
        }
        var d = JSON.parse(data);
        setItemList(d);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'ID',
            srno: true
        });

        columns.push({
            label: 'DOC',
            name: 'DOC'
        });

        columns.push({
            label: 'Subject',
            name: 'Name'
        });

        columns.push({
            label: 'Request To',
            name: 'FirmName'
        });
        columns.push({
            label: 'Description',
            name: 'Description',
            ReadOnlyTextArea: true
        });
        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });
        columns.push({
            label: 'CallRemark',
            name: 'UplineRemark',
            ReadOnlyTextArea: true
        });

        setMainColumns(columns);
    };

    useEffect(() => {
        setLoadingOpen(true);
        createColumns();
        selectParent();
        selectCategory();
        selectData();
    }, []);

    const [formObject, setFormObject] = useState({
        CallMeCategoryMasterID: 0,
        UplineUserID: 0,
        Description: ''
    });

    const FormValidationSchema = Yup.object({
        UplineUserID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'request to')
            .required(PLEASE_SELECT_VALID + 'request to'),

        CallMeCategoryMasterID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + 'call Subject')
            .required(PLEASE_SELECT_VALID + 'call Subject'),

        Description: Yup.string().required(PLEASE_PROVIDE_VALID + 'description')
    });

    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (loadingOpen) {
            setLoadingOpen(false);
            return;
        }
        var requestObj = JSON.stringify(values);
        setSubmitting(false);
        setIsError(false);
        setLoadingOpen(true);

        var response = await CALLREQUEST_INSERT(requestObj);

        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        setSubmitting(true);
        setSeverity('success');
        setResponseMessage(response.data);
        setIsError(true);

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            return;
        }

        resetForm(formObject);

        setFormObject({
            CallMeCategoryMasterID: 0,
            UplineUserID: 0,
            Description: ''
        });

        setTimeout(() => {
            selectData();
        }, MESSAGE_CLOSE_AFTER);
    };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
            >
                {() => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>Call Me</h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialSelect
                                                label="Request To"
                                                name="UplineUserID"
                                                title="Request To"
                                            >
                                                <MenuItem
                                                    key="0"
                                                    value="0"
                                                    selected={true}
                                                >
                                                    Select Request To
                                                </MenuItem>
                                                {requestToList.map((item) => (
                                                    <MenuItem
                                                        key={item.ParentID}
                                                        value={item.ParentID}
                                                    >
                                                        {item.FirmName}--
                                                        {item.MobileNumber}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialSelect
                                                label="Subject"
                                                name="CallMeCategoryMasterID"
                                            >
                                                <MenuItem key="0" value="0">
                                                    Select Call Subject
                                                </MenuItem>
                                                {Subject.map((Item) => (
                                                    <MenuItem
                                                        key={
                                                            Item.CallMeCategoryMasterID
                                                        }
                                                        value={
                                                            Item.CallMeCategoryMasterID
                                                        }
                                                    >
                                                        {Item.Name}
                                                    </MenuItem>
                                                ))}
                                            </MaterialSelect>
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={4}
                                            lg={4}
                                        >
                                            <MaterialTextField
                                                label="Description"
                                                name="Description"
                                                type="text"
                                                placeholder="Description"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Add"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loadingOpen}
                                        >
                                            Add
                                        </Button>
                                        {loadingOpen && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>

            <ReactTable data={itemList} columns={mainColumns} />
        </CustomContainer>
    );
};
